/* ks-field-mode.js: additive default-off Field Mode toggle. Persists via localStorage. Added 2026-07-07 (KS v18).
   10 Oct 2026 (K-39, KZU-11): the toggle no longer floats over the page. It is placed in the header icon row
   (next to search and the quote button), so it never covers text and moves with the header. Fallback when a
   layout has no header: the footer's bottom row; last resort: the old floating button. Label in English or
   Filipino from the page language. */
(function(){
  var KEY='ks-field-mode';
  function lang(){ return ((document.documentElement.lang||'en').split('-')[0]||'en').toLowerCase(); }
  function build(){
    if(document.querySelector('.ks-fieldmode-toggle'))return;
    var fil = lang()==='fil';
    var b=document.createElement('button');
    b.type='button';
    b.className='ks-fieldmode-toggle';
    b.setAttribute('aria-pressed','false');
    b.setAttribute('aria-label', fil ? 'Field mode: mas madaling basahin sa matinding sikat ng araw' : 'Field mode: easier reading in bright sunlight');
    b.innerHTML='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><circle cx="12" cy="12" r="4"/><path d="M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4"/></svg><span class="ks-fieldmode-toggle__txt">Field mode</span>';
    b.addEventListener('click',function(){
      var on=document.body.classList.toggle('ks-field-mode');
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      try{ localStorage.setItem(KEY, on ? 'on' : 'off'); }catch(e){}
    });
    var icons=document.querySelector('.header__icons');
    var bottom=document.querySelector('footer .footer__content-bottom-wrapper, footer .footer__content-bottom');
    if(icons){
      b.classList.add('ks-fieldmode-toggle--header');
      var quote=icons.querySelector('.ks-header-quote');
      if(quote){ icons.insertBefore(b, quote); } else { icons.appendChild(b); }
    } else if(bottom){
      b.classList.add('ks-fieldmode-toggle--footer');
      bottom.appendChild(b);
    } else {
      b.classList.add('ks-fieldmode-toggle--float');
      document.body.appendChild(b);
    }
    var saved=null; try{ saved=localStorage.getItem(KEY); }catch(e){}
    if(saved==='on'){ document.body.classList.add('ks-field-mode'); b.setAttribute('aria-pressed','true'); }
  }
  if(document.readyState!=='loading')build(); else document.addEventListener('DOMContentLoaded',build);
})();
